<template>
    <div>
        <div class="headingWizard hidePrint">
            Enquire Appointment Details
        </div>
        <div class="widthContainer">
            <div class="pageLayout">
                <div class="infoText">
                    <div class="hidePrint">
                        <p class="mtDetails">
                            Your appointment details are:
                        </p>
                    </div>
                    <div class="ackDetails hideOnView">
                        <h3 class="latoFont">Thank you!</h3>
                        <p>
                            You have successfully scheduled your appointment at Land Transport Authority Customer
                            Service Centre, 10 Sin Ming Drive, Singapore 575701. An SMS and/or email notification will
                            be sent to you shortly.
                        </p>

                        <ul class="listBullet">
                            <li>
                                Please arrive 15 minutes ahead of your appointment time. If you are late, your
                                appointment may be delayed or cancelled.
                            </li>
                            <li>
                                When you arrive, obtain a queue number at the self-help kiosk by scanning the QR code
                                provided in the email, or by entering the Appointment Reference ID
                                <b>{{ appointmentDetails.referenceNumber }}</b>.
                            </li>
                        </ul>

                        <div v-html="appointmentDetails.postBookingMessage" class="postMessageMargin"></div>
                        <div v-html="appointmentDetails.oldPostBookingMessage" class="postMessageMargin"></div>

                    </div>
                </div>
                <div class="formConatiner">
                    <p v-if="appointmentDetails.appointmentStatus == 'Cancelled'">
                        <span class="m-0 canclledText">
                            Your appointment has been cancelled.
                        </span>
                    </p>
                    <div class="infoTable">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <div class="lableText"> Appointment Date </div>
                                        <div class="detailsText">
                                            {{ appointmentDateString }}
                                        </div>
                                    </th>
                                    <th>
                                        <div class="lableText">
                                            Appointment Time
                                        </div>
                                        <div class="detailsText">
                                            {{ formatTime12(appointmentDetails.startTime) }}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="appointmentDetails.appointmentStatus == 'Open'">
                                <tr>
                                    <td colspan="2">
                                        <div class="barCode" v-if="isShowQrcode">
                                            <qrcode-vue :value="value" size="150" level="H"></qrcode-vue>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td colspan="2">
                                        <div class="lableText">
                                            Name
                                        </div>
                                        <div class="detailsText">
                                            {{ appointmentDetails.name }}
                                        </div>
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        <div class="lableText">
                                            Mobile Number
                                        </div>
                                        <div class="detailsText">
                                            <span v-if="appointmentDetails.phoneNumber">
                                                <span class="hidePrint"> {{ appointmentDetails.phoneNumber }} </span>
                                                <span class="hideOnView">{{ maskingText(appointmentDetails.phoneNumber,
                                                    4) }} </span>
                                            </span>
                                            <span v-else>
                                                -
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="lableText">
                                            Email Address
                                        </div>
                                        <div class="detailsText">
                                            <span v-if="appointmentDetails.email">
                                                <span class="hidePrint"> {{ appointmentDetails.email }} </span>
                                                <span class="hideOnView">{{ emailMask(appointmentDetails.email)
                                                }}</span>
                                            </span>
                                            <span v-else>
                                                -
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="lableText">
                                            Service Name
                                        </div>
                                        <div class="detailsText">
                                            {{ appointmentDetails.serviceName }}
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="p-0">
                                        <div class="appInfoDetails" v-if="isVehicalShow">
                                            <div class="lableText">
                                                Vehicle Number
                                            </div>
                                            <div class="detailsText">
                                                {{ capitalize(appointmentDetails.vehicleNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isNoticeShow">
                                            <div class="lableText">
                                                Notice Number
                                            </div>
                                            <div class="detailsText">
                                                {{ capitalize(appointmentDetails.noticeNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isVacShow">
                                            <div class="lableText">
                                                VAC Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.vacNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isPARFShow">
                                            <div class="lableText">
                                                PARF Number
                                            </div>
                                            <div class="detailsText">
                                                {{ capitalize(appointmentDetails.parfNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isCEORShow">
                                            <div class="lableText">
                                                COE Number
                                            </div>
                                            <div class="detailsText">
                                                {{ capitalize(appointmentDetails.coeNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isTcoeShow">
                                            <div class="lableText">
                                                TCOE Number
                                            </div>
                                            <div class="detailsText">
                                                {{ capitalize(appointmentDetails.tcoeNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="ishVParkShow">
                                            <div class="lableText">
                                                HV Park Number
                                            </div>
                                            <div class="detailsText">
                                                {{ capitalize(appointmentDetails.hvParkNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isDeviceNumberShow">
                                            <div class="lableText">
                                                Device Number
                                            </div>
                                            <div class="detailsText">
                                                {{ capitalize(appointmentDetails.deviceNumber) }}
                                            </div>
                                        </div>

                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
                                            <div class="lableText">
                                                Notes to LTA
                                            </div>
                                            <div class="detailsText" v-html="appointmentDetails.remarks">
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="appointmentDetails.appointmentStatus == 'Cancelled'">
                                    <td colspan="2">
                                        <div v-if="appointmentDetails.appointmentStatus == 'Cancelled'">
                                            <div class="lableText">
                                                Reason for Cancellation
                                            </div>
                                            <div class="detailsText">
                                                {{ appointmentDetails.cancelledRemark }}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="lableText">
                                            Appointment Reference ID
                                        </div>
                                        <div class="detailsText">
                                            {{ appointmentDetails.referenceNumber }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="lableText">
                                            Transaction Date & Time
                                        </div>
                                        <div class="detailsText">
                                            {{ appointmentTrasactDateTime }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p>
                        <div v-if="appointmentDetails.appointmentStatus == 'Open'" />
                    </p>
                    <p v-if="appointmentDetails.appointmentStatus == 'Open'" class="m-0">
                        Your appointment will be at Land Transport Authority Customer Service Centre, 10 Sin Ming Drive,
                        Singapore 575701.
                    </p>
                </div>

                <div class="buttonContainer hidePrint viewButtonRes">
                    <Button v-if="appointmentDetails.appointmentStatus != 'Open'" label="< Home" @click="onHomeclick()"
                        class="linkBtn customLinkCss" />
                    <Button v-if="appointmentDetails.appointmentStatus == 'Open'" tabindex="1" label="< Back"
                        @click="onBackAction" class="linkBtn" />
                    <Button v-if="appointmentDetails.appointmentStatus == 'Open'" @click="saveAsPdf" tabindex="2"
                        label="Save as PDF" class="btn p-button-raised " />
                    <Button tabindex="3" v-if="appointmentDetails.appointmentStatus == 'Open'" label="Print"
                        @click="printWindow()" class="btn p-button-raised " />
                    <Button tabindex="4"
                        v-if="appointmentDetails.appointmentStatus == 'Open' && !appointmentDetails.blockReschedule && !appointmentDetails.isOfficer"
                        label="Reschedule Appointment" @click="onNextAction" class="btn p-button-raised " />
                    <Button tabindex="5"
                        v-if="appointmentDetails.appointmentStatus == 'Open' && !appointmentDetails.isExpired && !appointmentDetails.isOfficer"
                        label="Cancel Appointment" @click="onCancelAction" class="btn p-button-raised " />
                </div>

            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, computed, watch, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import QrcodeVue from 'qrcode.vue';
import { useApiService } from '@/utils/useApiService';
import { useNotifications } from '@/utils/useNotifications';
import { defineEmits } from 'vue'
const emit = defineEmits(['nextClick', 'backClick'])
const { notifyError, notifyInfoError } = useNotifications()
const { fetchWrapperForGet } = useApiService()
const store = useStore();
const router = useRouter();

const value = ref('');
const id = ref(null);
const url = ref('');
const isShowQrcode = ref(false);

const isVehicalShow = ref(false);
const isNoticeShow = ref(false);
const isVacShow = ref(false);
const isPARFShow = ref(false);
const isCEORShow = ref(false);
const isTcoeShow = ref(false);
const ishVParkShow = ref(false);
const isDeviceNumberShow = ref(false);

const appointmentTrasactDateTime = ref('');
const appointmentDateString = ref('');

const appointmentDetails = ref({
    name: '',
    phoneNumber: '',
    email: '',
    serviceName: '',
    vehicleNumber: '',
    noticeNumber: '',
    vacNumber: '',
    parfNumber: '',
    coeNumber: '',
    tcoeNumber: '',
    hvParkNumber: '',
    remarks: '',
    blockReschedule: false,
    deviceNumber: '',
    referenceNumber: '',
    appointmentDateTime: '',
    postBookingMessage: '',
    generateDateTime: '',
    preferredTime: '',
    preferredDate: '',
    cancelledRemark: '',
    oldPostBookingMessage: '',
    appointmentStatus: '',
    isExpired: false,
    isOfficer: false,
});

const maskingText = (value, lastCharCount) => {
    value = value.toString();
    if (value.length > lastCharCount) {
        return '*'.repeat(value.length - lastCharCount) + value.slice(-lastCharCount);
    }
    return value;
};

const emailMask = (email) => {
    let maskedEmail = email.replace(/([^@\.])/g, '*').split('');
    const ind = email.indexOf('@');
    for (let i = 0; i <= ind; i++) {
        maskedEmail[i] = email[i];
    }
    return maskedEmail.join('');
};

const onHomeclick = () => {
    store.dispatch('reset').then(() => {
        router.push({ path: '/' });
    });
};

const onBackAction = () => {
    emit('backClick');
};

const onNextAction = () => {
    fetchWrapperForGet(`api/HeartBeat`, false, false, false)
        .then(() => {
            emit('nextClick');
        })
        .catch((err) => {
            if (err.errorCode === 422) {
                notifyInfoError('Your session has expired due to inactivity. Please  try again.', okFunction);
            } else {
                notifyError(err);
            }
        });
};
function capitalize(value) {
    if (!value) return "";
    value = value.toString();
    return value.toUpperCase();
}
const onCancelAction = () => {
    fetchWrapperForGet(`api/HeartBeat`, false, false, false)
        .then(() => {
            router.push({ path: '/cancelappointmentpage' });
        })
        .catch((err) => {
            if (err.errorCode === 422) {
                notifyInfoError('Your session has expired due to inactivity. Please  try again.', okFunction);
            } else {
                notifyError(err);
            }
        });
};

const saveAsPdf = () => {
    fetchWrapperForGet(`api/HeartBeat`, false, false, false)
        .then(() => {
            window.open(url.value);
        })
        .catch((err) => {
            if (err.errorCode === 422) {
                notifyInfoError(
                    'Your session has expired due to inactivity. To download appointment details, please select "Enquire / Manage Appointment" option and try again.',
                    okFunction
                );
            } else {
                notifyError(err);
            }
        });
};

const printWindow = () => {
    window.print();
};

const okFunction = () => {
    fetchWrapperForGet(`api/MopSessions/Delete`, false, false, true).then(() => {
        store.dispatch('reset').then(() => {
            window.location.reload();
        });
    });
};

const getData = () => {
    appointmentDetails.value = store.getters.getAppointmentAcknowlegement;
    appointmentDateString.value = store.getters.getAppointmentDateString;
    appointmentTrasactDateTime.value = store.getters.getTransactionDateString;
    id.value = store.getters.getAppointmentId;
    url.value = `api/api/appointments/file?pdfType=enquiry`;
    value.value = appointmentDetails.value.referenceNumber;
    isShowQrcode.value = true;
};

onBeforeMount(() => {
    getData();
});

watch(() => appointmentDetails.value.vehicleNumber, val => isVehicalShow.value = !!val);
watch(() => appointmentDetails.value.noticeNumber, val => isNoticeShow.value = !!val);
watch(() => appointmentDetails.value.vacNumber, val => isVacShow.value = !!val);
watch(() => appointmentDetails.value.parfNumber, val => isPARFShow.value = !!val);
watch(() => appointmentDetails.value.coeNumber, val => isCEORShow.value = !!val);
watch(() => appointmentDetails.value.tcoeNumber, val => isTcoeShow.value = !!val);
watch(() => appointmentDetails.value.hvParkNumber, val => ishVParkShow.value = !!val);
watch(() => appointmentDetails.value.deviceNumber, val => isDeviceNumberShow.value = !!val);

function formatTime12(value) {
    if (value) {
        const [hoursStr, minutesStr] = value.split(':');
        let hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // convert 0 to 12 for 12-hour format

        return `${hours}:${String(minutes).padStart(2, '0')} ${ampm}`;
    }
    return value;
}
</script>

<style>
.infoText {
    margin-bottom: 5px;
    margin-top: 5px;
}

.infoTexttop {
    margin-bottom: 50px;
    margin-top: 5px;
}

.mtDetails {
    margin: 30px 0 0 0;
}

.hideOnView {
    visibility: hidden;
    height: 0;
    overflow: hidden;
    display: none;
}

.barCode {
    display: flex;
    justify-content: center;
}

@media print {
    .hidePrint {
        visibility: hidden;
        height: 0;
        overflow: hidden;
        display: none;
    }

    .hideOnView {
        visibility: visible;
        height: auto;
        overflow: auto;
        display: block;
    }
}

@media only screen and (max-width: 718px) {
    .viewButtonRes .btn {
        width: 100%;
    }

    .viewButtonRes .linkMarginRes {
        margin: 0 !important;
    }
}

.canclledText {
    font-weight: bold;
}
</style>
